import Cursor from './assets/cursor.svg';

import Popper from '@material-ui/core/Popper';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { createGlobalStyle } from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`;

/**
 * Estilização do componente ToolOptions
 */
export const ToolOptions = styled(Popper)`
  display: flex;
  position: absolute;
  bottom: -65px;
  background: ${({ theme }) => theme.primaryColorDark};
  min-width: 100px;
  height: 40px;
  z-index: 400;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5) inset;
  padding: 0 15px;

  hr {
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    margin: 0 10px;
    height: 100%;
  }
`;

/**
 * Estilização do componente ChangeCursor
 */
export const ChangeCursor = createGlobalStyle`
  #map, .leaflet-interactive {
    cursor: url(${Cursor}) 13 12, auto !important;
  }
`;
